import { defineCopy } from '@/copy';

/** Default strings of the UI kit. Every prop that shows one can be overridden by the caller. */
export const uiCopy = defineCopy('ui', {
  loading: 'Working on it',
  close: 'Close',
  back: 'Back',
  dismiss: 'Dismiss',
  newCount: '{n} new',
  hold: {
    holding: 'Keep holding',
    armed: 'Tap again to confirm',
    hint: 'Press and hold to confirm',
  },
  confirm: { cancel: 'Nah' },
  rating: {
    pending: 'Combine pending',
    provisional: 'Provisional',
    rusty: 'Rusty',
    unknown: 'not rated yet',
  },
  code: { progress: '{n} of {total}' },
});
